<template>
    <div style="position: relative"> 
        <!-- <div v-if="!loading&this.$store.state.events.events.size=0">データが見つかりません。</div> -->
        <!-- <div v-if="loading">ロード中・・・</div> -->

        <v-card class="ma-4" v-for="event in this.$store.state.events.events" v-bind:key="event.id">
            <eventLayout :eventData='event'>
            </eventLayout>
        </v-card>

        <router-link :to="{name:this.return_address}">
            <v-btn>
                戻る
            </v-btn>
        </router-link>
    </div>
</template>



<script>
    import { mapActions, mapGetters } from "vuex";
    import eventLayout from './eventLayout.vue'

    export default {
       
        components: {
            eventLayout,
        },
        // props: ["navItem", "event_type"],

        data() {
            return {
                return_address : 'seminar.calendar'
            };
        },


        mounted () {
            console.log(this.$route)
            if(this.$route.params.return_address){
                this.return_address = this.$route.params.return_address;
            }
            this.clearEvent();
            // this.getEventDataById(this.$route.params.gc_id);
            this.getEventDataById(this.$route.query.id);
        },

        methods:{
            ...mapActions(["clearEvent", "getEventDataById"]),
            ...mapActions('ui', ["getDayOfWeek"]),
        },
        computed:{
            ...mapGetters(['login_user', 'loading']),
        }
    };
  
</script>

<style scoped lang="scss">
a{
    text-decoration :none;
}
</style>